// Importing the ReactNode type to define children props that can be any valid React element or text
import { type ReactNode } from 'react';
// Importing the AuthContext which holds authentication-related state and functions
import { AuthContext } from './AuthContextUtils';
// Importing the custom hook useAuth to manage authentication logic (user state, login, logout, etc.)
import { useAuth } from '../hooks/useAuth';

// AuthProvider component that wraps the application and provides authentication context
export function AuthProvider({ children }: { children: ReactNode }) {
  // Extracting authentication state and functions from the useAuth hook
  const { user, isLoading, login, logout, refreshUser } = useAuth();
  return (
    // Providing authentication values to all child components via React Context
    <AuthContext.Provider value={{ user, isLoading, login, logout, refreshUser }}>
      {/* Rendering child components inside the provider so they can access the context */}
      {children}
    </AuthContext.Provider>
  );
}
